import { inject, Injectable } from '@angular/core';

import { UISocketDataMessage } from '../../shared/models/UISocket';
import { SocketAction, SocketActionHandler } from '../../shared/services/SocketActionHandler';
import { DeviceId } from '../models/Device';
import { SiteId } from '../models/Site';
import { SiteDevicesStore } from '../site-devices.store';

interface UISocketDeviceRemoved extends UISocketDataMessage {
    deviceId: DeviceId;
    siteId: SiteId;
}

@Injectable()
export class DeviceRemovedHandler implements SocketActionHandler {
    readonly action: SocketAction = 'deviceRemoved';

    private readonly siteDevices = inject(SiteDevicesStore);

    handle(message: UISocketDeviceRemoved): void {
        this.siteDevices.deviceRemoved(message.siteId, message.deviceId);
    }
}
